import { RoutePath } from '../models';
import { applicationRoutes } from '../const';

export const getRoute = (path: RoutePath) =>
  applicationRoutes.find(
    route => route.path === path || route.path === RoutePath.Error
  )!;
